import { put, takeLatest, all } from "redux-saga/effects";
import { CHECK_ACCESS } from "../constants/auth";
import { checkUserAccessSuccess, checkUserAccessError } from "../actions/auth";

import { accessTokenLoginApi } from "../../apiCalls/auth";

function* checUserAccess(action) {
  try {
    const response = yield accessTokenLoginApi(action.payload);
    if (response.data.statusCode === 200) {
      let result = response.data.data;

      yield put(checkUserAccessSuccess(result));
    } else if (
      response.data.statusCode === 400 ||
      response.data.statusCode === 401 ||
      response.data.statusCode === 403
    ) {
      yield put(checkUserAccessError(response.data.message));
    } else if (response.status === 500) {
      yield put(
        checkUserAccessError(
          "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        )
      );
    }
  } catch (error) {
    yield put(
      checkUserAccessError(
        "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
      )
    );
    if (process.env.NODE_ENV !== "production") {
      //console.log(error);
    }
  }
}

export default function* authSaga() {
  yield all([takeLatest(CHECK_ACCESS, checUserAccess)]);
}
